<script>import InstantSearch, {} from "instantsearch.js/es/lib/InstantSearch";
import { history } from "instantsearch.js/es/lib/routers";
import { setInstantSearchContext } from "./instantSearchContext";
import { tick } from "svelte";
import { getServerContext } from "./getServerState";
import { page } from "$app/stores";
import { setIndexContext } from "./indexContext";
import { onDestroyClientSide } from "./utils";
export let indexName;
export let searchClient;
export let stalledSearchDelay = void 0;
export let routing = void 0;
export let onStateChange = void 0;
export let initialUiState = void 0;
export let insights = void 0;
export let numberLocale = void 0;
let search;
export function setUiState(state) {
  search.setUiState(state);
}
;
export function refresh() {
  search.refresh();
}
const serverContext = getServerContext();
$:
  if (searchClient) {
    search = new InstantSearch({
      indexName,
      searchClient,
      stalledSearchDelay,
      onStateChange,
      initialUiState,
      insights,
      numberLocale,
      routing: routing && {
        router: history({
          getLocation() {
            if (typeof window === "undefined") {
              if (serverContext) {
                return new URL(serverContext.serverUrl);
              } else {
                let serverUrl;
                page.subscribe(({ url }) => {
                  serverUrl = url;
                });
                return new URL(serverUrl);
              }
            }
            return window.location;
          }
        })
      }
    });
    setInstantSearchContext(search);
    setIndexContext(search.mainIndex);
    if (!serverContext) {
      page.subscribe(({ data }) => {
        if (Object.keys(data).includes(indexName)) {
          search._initialResults = data;
        }
      });
    }
    search.start();
    if ("addAlgoliaAgent" in searchClient) {
      searchClient.addAlgoliaAgent("svelte-meilisearch-instantsearch", "1.0.0");
    }
    if (serverContext) {
      tick().then(() => {
        serverContext.notifyServer(search);
      });
    }
  }
onDestroyClientSide(() => {
  search.dispose();
});
</script>

{#if search}
  <slot />
{/if}
